/**
 * React Query keys for Jobs feature
 * Centralized key management for cache consistency
 */
export const JOBS_QUERY_KEYS = {
  JOBS: ["jobs"],
  JOBS_INFINITE: ["jobs", "infinite"],
  JOB_SINGLE: (id: string) => ["jobs", "single", id],
} as const;
